// extracted by mini-css-extract-plugin
module.exports = {"stars":"review-stars_stars__daP1S","count":"review-stars_count__EXcMN","container":"review-stars_container__W35Mq"};